<template>
  <v-app :style="{ background: isBackgroundRouteDoorphone ? '#F5F5F5' : 'transparent' }">
    <router-view v-if="isOAuthCallback" />
    <v-container
      v-else-if="isAuth"
      fluid
      :class="{ 'background-route-home' : isBackgroundRoute, 'background-route-doorphone' : isBackgroundRouteDoorphone }"
    >
      <app-header></app-header>
      <app-sidebar></app-sidebar>
      <app-content></app-content>
    </v-container>
    <sign-in v-else></sign-in>
    <div class="preloader" v-if="loading">
      <v-progress-circular
        :size="75"
        :width="7"
        color="primary"
        :indeterminate="loading"
        class="preloader-circular"
      >
      </v-progress-circular>
    </div>
    <notification></notification>
    <mass-audio-upload-result-dialog v-if="isAuth" />
  </v-app>
</template>

<script>
import AppHeader from '@/components/app/AppHeader';
import AppSidebar from '@/components/app/AppSidebar';
import AppContent from '@/components/app/AppContent';
import SignIn from '@/components/SignIn';
import isAuthMixin from '@/mixins/isAuth';
import { mapActions, mapGetters } from 'vuex';
import Notification from '@/modules/notifications/notifications';
import MassAudioUploadResultDialog from '@/components/massOpenDoorSound/MassAudioUploadResultDialog.vue';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppSidebar,
    AppContent,
    SignIn,
    Notification,
    MassAudioUploadResultDialog,
  },
  mixins: [isAuthMixin],
  data () {
    return {
      isBackgroundRoute: false,
      isBackgroundRouteDoorphone: false,
    };
  },
  computed: {
    ...mapGetters({
      loading: 'loading',
      roleName: 'roleName',
      userId: 'userId',
    }),
    isOAuthCallback () {
      return this.$route.name === 'OAuthCallback' || this.$route.path === '/auth/callback';
    },
  },
  watch: {
    isAuth (val) {
      if (!val) {
        this.isAuth = false;
      }
    },
  },
  mounted () {
    this.updateBackgroundRoute();
    this.loadAllAgents();
    this.getAllSettingsTables();

    this.$router.afterEach((to, from) => {
      this.updateBackgroundRoute(to);
    });
  },

  methods: {
    ...mapActions({
      loadAllAgents: 'Agents/loadAllAgents',
      getAllSettingsTables: 'User/getAllSettingsTables',
    }),
    updateBackgroundRoute (to = this.$router.currentRoute) {
      this.isBackgroundRoute = to.name === 'Home';

      if (to.name === 'DetailDoorphone') {
        this.isBackgroundRouteDoorphone = true;
      } else {
        this.isBackgroundRouteDoorphone = to.name === 'DetailBarrier' || to.name === 'DetailGate';
      }
    },
  },
};
</script>

<style lang="scss">
@import './scss/fonts';
@import './scss/defaults';

body,
#app {
  font-family: 'SF Pro Display';
  font-size: 16px;
  line-height: 16px;
}

.background-route-home {
  background: linear-gradient(300deg, rgba(91,19,110,1) 0%, rgba(49,62,129,1) 88%);
}
.background-route-doorphone {
  background: #F5F5F5;
}
.preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  &:before {
    position: fixed;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0,0,0, .2);
  }

  &-circular {
    z-index: 3;
  }
}
</style>
